import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import "./TrashTypesList.css";

interface TrashTypesListProps {
  trashTypes: number[];
}

const getTrashTypeInfo = (t: any): Record<number, { label: string; icon: string }> => ({
  1: { label: t("trash.domestic"), icon: `${process.env.PUBLIC_URL}/images/domestic.png` },
  2: { label: t("trash.construction"), icon: `${process.env.PUBLIC_URL}/images/construction.png` },
  3: { label: t("trash.hazardous"), icon: `${process.env.PUBLIC_URL}/images/dangerous.png` },
  4: { label: t("trash.liquid"), icon: `${process.env.PUBLIC_URL}/images/liquid.png` },
});

const TrashTypesList: React.FC<TrashTypesListProps> = memo(({ trashTypes }) => {
  const { t } = useTranslation();
  const TRASH_TYPE_INFO: Record<number, { label: string; icon: string }> = getTrashTypeInfo(t);
  if (!trashTypes || trashTypes.length === 0) {
    return null;
  }

  return (
    <div className="trash-types-list">
      {trashTypes.map((typeIndex) => {
        const typeInfo = TRASH_TYPE_INFO[typeIndex];
        if (!typeInfo) return null;

        return (
          <div key={typeIndex} className="trash-type-item">
            <img
              src={typeInfo.icon}
              alt={typeInfo.label}
              className="trash-type-icon"
            />
            <span className="trash-type-label">{typeInfo.label}</span>
          </div>
        );
      })}
    </div>
  );
});

TrashTypesList.displayName = "TrashTypesList";

export default TrashTypesList;

